import { preloadImage } from '@mail/3promo';
import subscribedToVigboModalImage from 'img/vigbo/subscribedToVigboModal.png';
import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

const IMAGE_PRELOAD_TIMEOUT = 3 * 1000;

export const renderSubscribedToVigboModal = (data) => {
    openPopupHelper({
        popupName: popupNames.SUBSCRIBED_TO_VIGBO_MODAL,
        data,
    });
};

export const closeSubscribedToVigboModal = () => closePopupHelper(popupNames.SUBSCRIBED_TO_VIGBO_MODAL);

export const preloadCover = async () => {
    const coverImageUrl = subscribedToVigboModalImage;
    await preloadImage({ src: coverImageUrl, timeout: IMAGE_PRELOAD_TIMEOUT });
};
